import React, { useState, useEffect } from "react";
import axios from "axios";

export default function CheckoutPricing({ selectedMedicine }) {
  const [doses, setDoses] = useState([]);
  const [selectedDose, setSelectedDose] = useState("");
  const [loading, setLoading] = useState(false);

  // Clear previous selection when medicine changes
  useEffect(() => {
    setSelectedDose("");
    localStorage.removeItem("selectedMedicine");

    const fetchDoses = async () => {
      if (!selectedMedicine?.name) return;

      setLoading(true);
      try {
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
        const response = await axios.get(`${baseUrl}/dosages`, {
          params: { name: selectedMedicine.name },
        });

        if (response.data.length > 0) {
          setDoses(response.data);
        } else {
          setDoses([]);
        }
      } catch (error) {
        console.error("Error fetching doses:", error);
        setDoses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDoses();
  }, [selectedMedicine?.name]);

  const handleDoseSelect = (dose) => {
    setSelectedDose(dose.dose);

    // Save selected dose + id + price to localStorage
    localStorage.setItem(
      "selectedMedicine",
      JSON.stringify({
        ...selectedMedicine,
        selectedDose: dose.dose,
        treatmentId: dose.id, // use the id from API
        price: dose.price,
      })
    );
  };

  if (!selectedMedicine) {
    return <p className="text-center py-6">Select a medicine first</p>;
  }

  if (loading) {
    return <p className="text-center py-6">Loading doses...</p>;
  }

  return (
    <>
      <h1 className="text-[16px] font-medium text-black mb-2 mt-4">
        Checkout &amp; Begin Your Journey
      </h1>

      <p className="text-[14px] font-medium text-black">
        {selectedMedicine.name} + Dedicated Doctor
      </p>
      <p className="text-[12px] text-black mb-4">
        {selectedMedicine.description}
      </p>

      <p className="text-[14px] text-black mb-3">
        Select a dose: <span className="text-red-500">*</span>
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {doses.map((item) => {
          const isSelected = selectedDose === item.dose;

          return (
            <button
              key={item.id}
              type="button"
              onClick={() => handleDoseSelect(item)}
              className={`flex items-center justify-between w-full rounded-lg border px-4 py-3 text-[14px] transition
                ${isSelected ? "border-[#35C3D9] bg-[#E6F7FA]" : "border-gray-200 bg-white"}`}
            >
              <div className="flex items-center gap-3">
                <span
                  className={`flex items-center justify-center h-5 w-5 rounded-full border
                    ${isSelected ? "border-[#56C7D5]" : "border-gray-400"}`}
                >
                  {isSelected && <span className="h-3 w-3 rounded-full bg-[#35C3D9]" />}
                </span>
                <span className="text-black">{item.dose}</span>
              </div>
              <span className="text-black font-medium">£{item.price}</span>
            </button>
          );
        })}
      </div>
    </>
  );
}
